import { browserName, osName } from "react-device-detect";

export function isMobileSafari() {
  return (osName === 'iOS' && browserName === 'Mobile Safari') || (osName === 'Mac OS' && browserName === 'Safari');
}

export function isiOS() {
  return osName === 'iOS' || osName === 'Mac OS';
}
